import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface StoreHoursUpdateFailureProps extends BaseTemplateProps {
  retailerName: string
  whlLength: number
}

export const StoreHoursUpdateFailure: TemplateDefinition<StoreHoursUpdateFailureProps> = {
  renderParams: (props: StoreHoursUpdateFailureProps) => ({
    messageKey: 'notificationsDomain.templates.storeHoursUpdateFailure',
    values: {
      retailerName: props.retailerName,
      whlLength: props.whlLength,
    },
  }),
}
